<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div class="main-title">
      <v-container fill-height>
        <v-layout align-center>
          {{ $t("account_edit.title") }}
        </v-layout>
      </v-container>
    </div>
    <v-container class="lost-container">
      <v-layout>
        <v-flex>
          <div>
            {{ $t("account_edit.tip") }}
          </div>
        </v-flex>
      </v-layout>

      <v-form ref="form">
        <v-container>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="email"
                ref="email"
                :rules="nameRules"
                validate-on-blur
                :label="$t('account_edit.email')"
                required
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout :column="breakpoint.smAndDown">
            <v-flex xs6>
              <v-text-field
                ref="name"
                v-model="name"
                :rules="nameRules"
                validate-on-blur
                :label="$t('account_edit.name')"
                required
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="phone"
                ref="phone"
                :label="$t('account_edit.phone')"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-layout column>
        <v-flex>
          <button class="button shadow" @click="submit">
            {{ $t("account_edit.btn") }}
          </button>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="passwordTip" max-width="500px">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" flat @click="passwordTip = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const SECONDS = 6;
import { mapState } from "vuex";
import account from "@/api/account";

export default {
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      nameRules: [value => !!value || this.$t("login.rules")],
      showPassword1: false,
      showPassword2: false,
      isGettingCode: false,
      second: SECONDS,
      passwordTip: false,
      tip: this.$t("password.pwd_same")
    };
  },

  computed: {
    ...mapState(["guid", "userInfo"]),
    form() {
      return {
        name: this.name,
        email: this.email
      };
    },
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.home")
        },
        {
          to: { name: "account/info" },
          disabled: false,
          text: this.$t("breadcrumbs.account")
        },
        {
          to: { name: "account/edit" },
          disabled: true,
          text: this.$t("breadcrumbs.account_edit")
        }
      ];
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },

  created() {
    this.name = this.userInfo.name;
    this.phone = this.userInfo.phone;
    this.email = this.userInfo.email;
  },

  methods: {
    submit() {
      let isFull = true;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.$refs[f].validate(true);
          isFull = false;
        }
      });

      if (isFull) {
        console.log(this.form);
        if (this.password != this.comfrim_password) {
          this.passwordTip = true;
          return;
        }

        this.updateInfo();
      }
    },
    async updateInfo() {
      try {
        const res = await account.updateCustomer({
          ...this.form,
          phone: this.phone,
          guid: this.guid
        });

        if (!res.data.isError) {
          this.$router.back();
        } else {
          this.tip = res.data.msg;
          this.passwordTip = true;
        }
      } catch (e) {
        this.tip = e.response.data.msg;
        this.passwordTip = true;
      }
    }
  }
};
</script>
<style scoped lang="sass" src="./account-edit.sass"></style>
